import { useEffect } from "react";
import { SearchType } from "Dashboard/domain/SearchType";
import { useAppDispatch } from "hooks/hooks";
import {
  Control,
  Controller,
  UseFormGetValues,
  UseFormHandleSubmit,
  UseFormRegister,
  UseFormSetFocus,
  UseFormSetValue
} from "react-hook-form";
import { IGetResourcesListRequestParams } from "../../../domain/IGetResourcesListRequestParams";
import {
  getResourcesList,
  setSearchResourcesPopover,
} from "../main.slice";
import resClasses from "../../../styles/SearchResourcesPopover.module.scss";
import classes from "../../../../../../components/Popover/popover.module.scss";
import { faLongArrowAltDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ProjectSelect from "Dashboard/scenes/Projects/components/ProjectSelect";
import { styles } from "components/Popover/popoverSelectStyle";
import CategorySelect from "Dashboard/scenes/Resources/components/CategorySelect";

interface IProps {
  handleSubmit: UseFormHandleSubmit<IGetResourcesListRequestParams>;
  register: UseFormRegister<IGetResourcesListRequestParams>;
  control: Control<IGetResourcesListRequestParams, any>;
  getValues: UseFormGetValues<IGetResourcesListRequestParams>;
  searchType: SearchType;
  setSearchType: React.Dispatch<React.SetStateAction<SearchType>>;
  setFocus: UseFormSetFocus<IGetResourcesListRequestParams>;
  setValue: UseFormSetValue<IGetResourcesListRequestParams>;
};

const SearchResourcesPopover = (props: IProps) => {
  const dispatch = useAppDispatch();
  const {
    register,
    handleSubmit,
    control,
    getValues,
    setFocus,
    searchType,
    setSearchType
  } = props;

  const close = () => {
    dispatch(setSearchResourcesPopover({ isOpen: false }));
  };

  const switchSearchMode = (searchType: SearchType) => {
    setSearchType(searchType);
  };

  const onSubmit = async (data: IGetResourcesListRequestParams) => {
    try {
      if (props.searchType === SearchType.BASIC) {
        data = { searchTerm: data.searchTerm };
      } else {
        data.searchTerm = undefined;
      }
      let newFilter = {
        searchTerm: data.searchTerm,
        name: data.name,
        registration: data.registration,
        idNumber: data.idNumber,
        categoryId: data.categoryId,
        chargedOnProjectId: data.chargedOnProjectId,
        showRefuelsAtDate: getValues("showRefuelsAtDate"),
      };
      dispatch(getResourcesList(newFilter));
      close();
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (searchType === SearchType.BASIC) {
      setFocus("searchTerm");
    } else {
      setFocus("name");
    }
  }, [setFocus, searchType]);


  return (
    <form
      className={`${classes.basicPopover} ${resClasses.searchPopover}`}
      onSubmit={handleSubmit(onSubmit)}
    >
      {searchType === SearchType.BASIC && (
        <>
          <div className={classes.row}>
            <div className={`${classes.col} ${classes.colDir}`}>
              <input
                type="text"
                className={`${classes.fullWidth} ${classes.itemBorder}`}
                {...register("searchTerm")}
              />
            </div>
            <div className={classes.gPopoverDisclaimer}>
              * možete uneti više reči tj. kriterijuma pretrage
            </div>
          </div>

          <div className={classes.row}>
            <div className={classes.buttons}>
              <label
                onClick={() => switchSearchMode(SearchType.ADVANCED)}
                className={classes.clickableText}
              >
                NAPREDNA PRETRAGA
              </label>
              <button className={classes.iconButton} type="submit">
                <FontAwesomeIcon
                  icon={faLongArrowAltDown}
                  className={classes.icon} />
              </button>
            </div>
          </div>
        </>
      )}
      {searchType === SearchType.ADVANCED && (
        <>
          <div className={classes.row}>
            <div className={`${classes.col} ${classes.rowDir}`}>
              <label className={classes.mr5}>brend, marka, tip</label>
              <input type="text" className={classes.itemBorder} {...register("name")} />
            </div>
          </div>
          <div className={classes.row}>
            <div className={`${classes.col} ${classes.rowDir}`}>
              <label className={classes.mr5}>id broj</label>
              <input type="text" className={classes.itemBorder} {...register("idNumber")} />
            </div>
          </div>
          <div className={classes.row}>
            <div className={`${classes.col} ${classes.rowDir}`}>
              <label className={classes.mr5}>kategorija</label>
              <Controller
                name="categoryId"
                control={control}
                defaultValue={undefined}
                rules={{ required: false }}
                render={({ field: { onChange } }) => (
                  <CategorySelect
                    value={getValues("categoryId")}
                    customStyles={styles.customStyleClassic}
                    onChange={onChange}
                  />
                )}
              />
            </div>
          </div>
          <div className={classes.row}>
            <div className={`${classes.col} ${classes.rowDir}`}>
              <label className={classes.mr5}>registracija</label>
              <input type="text" className={classes.itemBorder} {...register("registration")} />
            </div>
          </div>
          <div className={classes.row}>
            <div className={`${classes.col} ${classes.rowDir}`}>
              <label className={classes.mr5}>zadužen na</label>
              <Controller
                name="chargedOnProjectId"
                control={control}
                defaultValue={undefined}
                rules={{
                  required: false,
                }}
                render={({ field: { onChange } }) => (
                  <ProjectSelect
                    value={getValues("chargedOnProjectId")}
                    onChange={onChange}
                    customStyles={styles.customStyleClassic}
                  />
                )}
              />
            </div>
          </div>
          <div className={classes.row}>
            <div className={classes.buttons}>
              <label
                onClick={() => switchSearchMode(SearchType.BASIC)}
                className={classes.clickableText}
              >
                PAMETNA PRETRAGA
              </label>
              <button className={classes.iconButton} type="submit">
                <FontAwesomeIcon
                  icon={faLongArrowAltDown}
                  className={classes.icon} />
              </button>
            </div>
          </div>
        </>
      )}
    </form>
  );
};

export default SearchResourcesPopover;
